






















import Vue from "vue";
import ContestRow from "@/components/molecules/ContestRow.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    ContestRow,
  },
  props: {
    contests: Array,
  },
  data() {
    return {
      selectedTab: "latest",
    };
  },
  methods: {
    onClickConfig() {
      const { $router } = this;
      $router.push({ name: "contest" });
    },
    onClickLatest() {
      this.selectedTab = "latest";
    },
    onClickEntry() {
      this.selectedTab = "entry";
    },
    onClickResult() {
      this.selectedTab = "result";
    },
  },
});

interface Props {
  contests: object[];
}

interface Data {
  selectedTab: Tab;
}

interface Computed {}

interface Methods {
  onClickConfig(): void;
  onClickLatest(): void;
  onClickEntry(): void;
  onClickResult(): void;
}

type Tab = "latest" | "entry" | "result";
